import Link from 'next/link'
import { GetStaticProps, GetStaticPaths } from 'next'
import AnalyticsTrigger from '../../../components/atoms/AnalyticsTrigger'
import { NextSeo, CourseJsonLd } from 'next-seo'
import Layout from '../../../components/templates/Layout'

const Course = ({course}: {course:any}) => {

  return (
    <Layout>
      <AnalyticsTrigger title={course.title} />
      <NextSeo
        title={course.title + " - デビクレ"}
        description={course.description}
      />
      <CourseJsonLd
        courseName={course.title}
        description={course.description}
        provider={{
          name: 'debicre',
          url: 'https://debicre.com',
        }}
      />
      <div>
        <div>
          <h1 style={{fontSize: "1.5rem",fontWeight: 700,color: "#8491a5", padding: "16px 0"}}>{course.title}</h1>
          <div>{course.description}</div>
          <div className="card-list">
            {course.chapters.map((chapter: any, i: number) => {
              return (
                <Link href={"/courses/" + course.id + "/chapters/" + chapter.index} prefetch={false} key={i}>
                  <a className="card">
                    <div>
                      <small className="">Chapter {chapter.index} - {chapter.lessons_count}レッスン</small>
                    </div>
                    <span>{chapter.title}</span>
                  </a>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  if (context.params) {
    const course_id = context.params.course_id
    const res = await fetch(process.env.NEXT_PUBLIC_BACKEND + 'courses/' + course_id + '/')
    const json = await res.json()
    const course = json.result
    if (!course || !Object.keys(course).length) {
      return {
        notFound: true,
      }
    }
    return { props: { course }, revalidate: 10}
  }
  return { notFound: true }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const res = await fetch(process.env.NEXT_PUBLIC_BACKEND + 'courses/?pagination_count=100')
  const json = await res.json()
  const courses = await json.result
  const paths = courses.map((course: any) => '/courses/' + course.id)
  return {paths, fallback: 'blocking'}
}

export default Course
